var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckedSymbol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.004,
    height: 34.004,
    viewBox: "0 0 34.004 34.004",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.725,8.468A16.931,16.931,0,0,0,25.537,2.28,16.631,16.631,0,0,0,17,0,16.631,16.631,0,0,0,8.468,2.28,16.927,16.927,0,0,0,2.28,8.468,16.631,16.631,0,0,0,0,17a16.634,16.634,0,0,0,2.28,8.534,16.931,16.931,0,0,0,6.188,6.188A16.633,16.633,0,0,0,17,34a16.633,16.633,0,0,0,8.535-2.28,16.926,16.926,0,0,0,6.187-6.188A16.634,16.634,0,0,0,34,17,16.635,16.635,0,0,0,31.725,8.468Zm-3.7,5.944L16.006,26.433a1.386,1.386,0,0,1-1.018.421,1.361,1.361,0,0,1-1-.421L5.977,18.419a1.352,1.352,0,0,1-.4-1,1.379,1.379,0,0,1,.4-1.019l2.015-1.992a1.391,1.391,0,0,1,1.993,0l5,5,9.032-9.01a1.39,1.39,0,0,1,1.992,0L28.027,12.4a1.377,1.377,0,0,1,.4,1.018A1.349,1.349,0,0,1,28.027,14.412Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedSymbol);
export default __webpack_public_path__ + "static/media/checked-symbol.71c081701bd78a8cd09c070c61a066f5.svg";
export { ForwardRef as ReactComponent };